<!-- 回测分析 -->
<template>
  <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="title">
      <p class="name">回测分析</p>
      <p class="right">
        持股周期
        <span> {{ periodArr.toString() }}天 </span>
      </p>
    </div>

    <div ref="hcfx">
      <div class="fc-title-sticky">
        <van-sticky :offset-top="tabsHeight + headerHeight - 2" :container="hcfx" z-index="98">
          <ul class="fc-title">
            <li></li>
            <li>持有期</li>
            <li>年化收益</li>
            <li>盈亏比</li>
            <li>历史胜率</li>
            <li style="text-align: right">最大回撤</li>
          </ul>
        </van-sticky>
      </div>
      <ul class="list" v-for="(item, index) in BacktestAnalysisResult" :key="index">
        <li class="zybox-list-left">
          <span class="zuiyou" v-if="MaxRetreatRateIndex === index">最优</span>
        </li>

        <li>{{ item.HoldPeriod }}天</li>
        <li :class="[judgeColor(item.YearRate)]">
          {{ toFixedNum(item.YearRate * 100, 2, '%') }}
        </li>
        <li>
          {{ toFixedNum(item.ProfitLossRatio, 2, '') }}
        </li>
        <li>{{ toFixedNum(item.SuccessRate * 100, 2, '%') }}</li>
        <li style="text-align: right">{{ toFixedNum(item.MaxRetreatRate * 100, 2, '%') }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { judgeColor, toFixedNum, formatStrTime } from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  name: 'Home',
  mixins: [mixin],
  props: ['BacktestAnalysisResult', 'holdPeriodList', 'headerHeight', 'tabsHeight'],
  data() {
    return {
      MaxRetreatRateIndex: 0,
      periodArr: '',
      hcfx: null
    };
  },
  filters: {},
  created() {},
  watch: {},
  mounted() {
    this.hcfx = this.$refs.hcfx;

    this.periodArr = this.holdPeriodList.split(',');
    var indices = this.getMaxIndices(this.BacktestAnalysisResult, 'YearRate');

    this.MaxRetreatRateIndex = indices.MaxRetreatRateIndex;
  },

  methods: {
    judgeColor,
    toFixedNum,
    formatStrTime,

    //获取最大值maxYearRate年化收益
    getMaxIndices: function (data, maxYearRateKey) {
      let MaxRetreatRateIndex = 0;
      let MaxRetreatRate = data[0][maxYearRateKey];

      for (let i = 1; i < data.length; i++) {
        if (data[i][maxYearRateKey] > MaxRetreatRate) {
          MaxRetreatRate = data[i][maxYearRateKey];
          MaxRetreatRateIndex = i;
        }
      }

      return {
        MaxRetreatRateIndex
      };
    }
  }
};
</script>
<style lang="less" scoped>
.index-info {
  padding: 15px;
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    .name {
      flex-shrink: 0;
    }
    p {
      font-weight: 600;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.9);
    }
    .right {
      font-weight: 400;
      font-size: 12px;
      color: #999;
      margin-left: 2px;
    }
  }
  .fc-title-sticky {
    ::v-deep {
      .van-sticky--fixed {
        left: 15px;
        right: 15px;
      }
    }
  }
  .fc-title {
    display: flex;
    align-items: center;
    border-top: 1px solid #f0f0f0;
    padding: 4px 0;
    background: #fff;
    width: 100%;
    li {
      font-weight: 400;
      font-size: 12px;
      color: #999;
      &:nth-child(1) {
        width: 10%;
      }
      &:nth-child(2) {
        width: 15%;
      }
      &:nth-child(3) {
        width: 22%;
      }
      &:nth-child(4) {
        width: 16%;
      }
      &:nth-child(5) {
        width: 19%;
      }
      &:nth-child(6) {
        width: 19%;
      }
    }
  }
  .zybox-list-left {
    // border: 1px solid red;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
  }
  .list {
    display: flex;
    align-items: center;
    border-top: 1px solid #f0f0f0;
    li {
      font-weight: 400;
      font-size: 14px;
      color: #555;
      height: 35px;
      line-height: 35px;
      &:nth-child(1) {
        width: 10%;
      }
      &:nth-child(2) {
        width: 15%;
      }
      &:nth-child(3) {
        width: 22%;
      }
      &:nth-child(4) {
        width: 16%;
      }
      &:nth-child(5) {
        width: 19%;
      }
      &:nth-child(6) {
        width: 19%;
      }
      .zuiyou {
        // flex-shrink: 0;
        // width: 28px;
        // height: 16px;
        // line-height: 16px;
        // border-radius: 2px;
        // font-weight: 400;
        // font-size: 10px;
        // color: #fff;
        // text-align: center;
        // padding: 1px 2px;
        // margin: 0 1px;
        width: 18px;
        height: 30px;
        line-height: 14px;  
        display: inline-flex;
        padding: 2px 3px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        color: #FFF;
        font-size: 10px;
        font-weight: 400;
        border-radius: 2px;
        margin-right: 4px;
      }
      .zuiyou {
        background: linear-gradient(270deg, #cd0000 0%, #f76825 100%);
      }
    }

    &:last-child {
      border-bottom: 1px solid #f0f0f0;
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title {
    .name {
      color: #e4e9fe;
    }
    .right {
      color: #6b7687;
    }
  }
  .list {
    .right {
      color: #e4e9fe;
    }
  }
  .fc-title-sticky {
    .fc-title {
      background: #191a24;
      border-top: 1px solid #2f3139;
      li {
        color: #6b7687;
      }
    }
  }
  .list {
    border-top: 1px solid #2f3139;
    &:last-child {
      border-bottom: 1px solid #2f3139;
    }
    li {
      color: #e4e9fe;
    }
  }
}
</style>
